/* unplugin-vue-components disabled */import { render } from "./LoggedCom.vue?vue&type=template&id=34b1e622&scoped=true&lang=pug"
import script from "./LoggedCom.vue?vue&type=script&setup=true&lang=js"
export * from "./LoggedCom.vue?vue&type=script&setup=true&lang=js"

import "./LoggedCom.vue?vue&type=style&index=0&id=34b1e622&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b1e622"]])

export default __exports__